import React from 'react';
import { SERVICE_VIEWS, SUPPORTED_SERVICES } from './ServiceConstants';

/**
 * Allow the user to select from a dropdown of supported Flow services, or they can choose to install an Integration or Custom Service
 * @param {String} selectedService = {} - String of which Service is being selected
 * @param {Function} selectServiceType = {} - Function to update ServiceController with new selected service details
 */
const NewServiceSelect = ({ selectedService, selectServiceType }) => (
    <>
        <label>
            Service Type
            <span className="input-required"> *</span>
        </label>
        <select
            key="service-select"
            className="form-control"
            value={selectedService}
            onChange={({ target }) => {
                const newService = SUPPORTED_SERVICES.find(service => service.name === (target ? target.value : ''));
                if (newService) {
                    selectServiceType(newService);
                } else {
                    selectServiceType({ name: null, description: null, url: null, view: SERVICE_VIEWS.NewServiceSelect });
                }
            }}
            required
        >
            <option
                key=""
                value=""
            >
                Please select a Service type
            </option>
            {
                SUPPORTED_SERVICES.map(region => (
                    <option 
                        key={region.name} 
                        value={region.name}
                    >
                        {region.name}
                    </option>
                ))
            }
        </select>
    </>
);

export default NewServiceSelect;
